const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: "#0a0a0a",
  },
  rotatingBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    fontSize: 12,
    fontWeight: 600,
    color: "#008236",
    backgroundColor: "#f0fdf4",
    border: "1px solid #b9f8cf",
    borderRadius: 999,
    px: 1,
    py: 0.25,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    mt: 0.5,
  },
  firstRow: { mt: 1.5 },
  field: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    px: 1,
    border: "1px solid",
    borderColor: "purple.light",
    borderRadius: 2,
    bgcolor: "#fff",
    "& .ProseMirror": {
      // emailEditor applies `my: 2` (16px) to .ProseMirror — override it.
      margin: "0 !important",
      padding: 0,
      minHeight: "unset",
      lineHeight: 1.3,
    },
    "& p": { margin: 0, lineHeight: 1.3 },
    "& .merge-tag, & .variable": { paddingTop: 0, paddingBottom: 0 },
  },
  numberInside: {
    flexShrink: 0,
    mr: 0.75,
    minWidth: 18,
    height: 18,
    px: 0.5,
    borderRadius: 1,
    backgroundColor: "#f3f3f5",
    color: "#717182",
    fontSize: 11,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  editorSlot: { flex: 1, minWidth: 0, py: 1.25 },
  removeButton: {
    flexShrink: 0,
    color: "#e7000b",
    "&:hover": { backgroundColor: "#fef2f2" },
  },
  cta: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    mt: 1,
    p: 1.5,
    border: "1px dashed",
    borderColor: "#b9f8cf",
    borderRadius: 3,
    bgcolor: "#f6fef9",
    cursor: "pointer",
    "&:hover": { bgcolor: "#f0fdf4" },
  },
  ctaIcon: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#008236",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
  },
  ctaTitle: { fontSize: 14, fontWeight: 600, color: "#008236" },
  ctaBody: { fontSize: 13, color: "#4a5565", mt: 0.25 },
  addAnother: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    mt: 1,
    color: "#008236",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": { textDecoration: "underline" },
  },
};

export default styles;
